import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { TreeSelect } from 'antd';
import { PlusCircleOutlined } from '@ant-design/icons';
import CategoryActions from '@Actions/categoryActions';
import H3Text from "@Uilib/h3Text";
import useClickOutside from '../../../hooks/useClickOutside';
import './style.scss'

const CategoryFilterNew = ({
  user, onChange, disabled, mainTitle, hideTitle, containerClassName, getSubCategories, subCategories, multiple,
  inputClassName, labelClassName, placeholder, style, getSubCategoriesLoading, noApiCall, allowClear, selectedCategory,
}) => {
  const [isUserReady, setIsUserReady] = useState(false);
  const [filteredTreeData, setFilteredTreeData] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');

  useEffect(() => {
    if (!isUserReady && !noApiCall) {
      getSubCategories();
      setIsUserReady(true);
    }
  }, [user, isUserReady, noApiCall]);

  useEffect(() => {
    if (searchKeyword) {
      const timer = setTimeout(() => {
        getSubCategories(searchKeyword);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [searchKeyword]);

  function convertToTreeData(data) {
    return data?.map((item) => ({
      value: item.product_category_id,
      title: item.product_category_name,
      children: item.sub_categories ? convertToTreeData(item.sub_categories) : [],
    }));
  }

  const highlightText = (text, highlight) => {
    if (!highlight.trim()) {
      return <span>{text}</span>;
    }
    const regex = new RegExp(`(${highlight})`, 'gi');
    const parts = text.split(regex);
    return parts.map((part) => (part.toLowerCase() === highlight.toLowerCase() ? <span style={{ color: 'rgb(22, 119, 255)' }}>{part}</span> : part));
  };

  const highlightTreeData = (data, keyword) => data?.map((item) => ({
    ...item,
    originalTitle: item.originalTitle || item.title, // Keep the original title
    title: highlightText(item.originalTitle || item.title, keyword),
    children: item.children ? highlightTreeData(item.children, keyword) : [],
  }));

  useEffect(() => {
    setFilteredTreeData(highlightTreeData(convertToTreeData(subCategories), searchKeyword));
  }, [subCategories, searchKeyword]);

  return (
    <div className={containerClassName}>
      {!hideTitle && (
        <div className={labelClassName || 'orgFormLabel'}>
          {mainTitle || 'Category'}
        </div>
      )}
      <div className={inputClassName}>
        <TreeSelect
          showSearch
          dropdownStyle={{
            maxHeight: 400,
            overflow: 'auto',
            minWidth: 300,
          }}
          switcherIcon={<PlusCircleOutlined />}
          allowClear={allowClear}
          treeData={filteredTreeData}
          value={selectedCategory}
          popupClassName="category-filter__dropdown"
          onChange={(value, title) => {
            onChange(value, title);
            setSearchKeyword('');
          }}
          multiple={!multiple}
          maxTagCount="responsive"
          onSearch={(value) => setSearchKeyword(value)}
          bordered={false}
          placeholder={placeholder}
          style={style}
          loading={getSubCategoriesLoading}
          disabled={disabled}
          filterTreeNode={(input, treeNode) => {
            const title = treeNode.originalTitle || treeNode.title;
            if (typeof title === 'string') {
              return <H3Text className="category-filter__dropdown-tag" text={title.toLowerCase().includes(input.toLowerCase())} />;
            }
            return false;
          }}
          onDropdownVisibleChange={(open) => {
            if (!open) {
              getSubCategories();
              setFilteredTreeData(convertToTreeData(subCategories));
            }
          }}
        />
      </div>
    </div>
  );
};

const mapStateToProps = ({ UserReducers, CategoryReducers }) => ({
  user: UserReducers.user,
  subCategories: CategoryReducers.subCategories,
  getSubCategoriesLoading: CategoryReducers.getSubCategoriesLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getSubCategories: (searchKeyword, page, limit) => dispatch(CategoryActions.getSubCategories(searchKeyword, page, limit)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CategoryFilterNew));
